import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import {
    SegmentsWarningBannerContainer,
    SegmentsWarningBannerContent,
} from "app/pages/segments/wizard/SegmentWizard/SegmentWizardStyles";

export const SegmentsAnalysisContainer = styled.div`
    padding: 24px 40px 40px 40px;
    display: flex;
    flex-direction: column;
    max-width: 100%;
    align-items: center;
`;
SegmentsAnalysisContainer.displayName = "SegmentsAnalysisContainer";

export const StyledSegmentsWarningBannerContainer = styled(SegmentsWarningBannerContainer)`
    padding: 14px 0px;
    justify-content: center;
    width: 100%;
    & + & {
        margin-top: 10px;
    }
    ${SegmentsWarningBannerContent} {
        margin-left: 25px;
    }

    max-width: 1368px;
    align-items: center;
    margin: 0 auto;
    box-sizing: border-box;
    margin-top: 10px;
`;

export const StyledSegmentsWarningBannerContent = styled(SegmentsWarningBannerContent)`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    max-width: 1368px;
    text-align: left;
`;

export const SegmentTypeBadge = styled.span`
    display: inline;
    padding: 5px 4px 3px;
    color: ${colorsPalettes.carbon[400]};
    background: ${colorsPalettes.carbon[50]};
    border-radius: 4px;
    font-size: 8px;
    line-height: 8px;
    text-transform: uppercase;
`;
